import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import http from "../../common/http-common";
import * as common from "../../common/common";
import * as Comp from "../../common/CommonComponents";
import save from "../../assets/save-icon.png";
import cancel from "../../assets/cancel-icon.png";

const ChangePasswordModal = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const oldPasswordInputRef = useRef();
  const userPasswordInputRef = useRef();
  const userCPasswordInputRef = useRef();

  const [editData, setEditData] = useState([]);
  const [inputError, setInputError] = useState([]);

  const hideModal = () => {
    setEditData([]);
    setInputError([]);
    props.onHide();
  };

  const saveBtnOnClick = () => {
    if (editData.OLD_PASSWORD === undefined) {
      setInputError((prevState) => ({
        ...prevState,
        OLD_PASSWORD: "Password could not be empty.",
      }));
    }
    if (editData.PASSWORD === undefined) {
      setInputError((prevState) => ({
        ...prevState,
        PASSWORD: "Password could not be empty.",
      }));
    } else {
      furtherValidateInput("PASSWORD", editData.PASSWORD);
    }
    if (editData.CONFIRM_PASSWORD === undefined) {
      setInputError((prevState) => ({
        ...prevState,
        CONFIRM_PASSWORD: "Confirm Password could not be empty.",
      }));
    } else {
      furtherValidateInput("CONFIRM_PASSWORD", editData.CONFIRM_PASSWORD);
    }
    if (Object.values(inputError).filter((v) => v !== "").length === 0) {
      ChangePassword();
    }
  };

  function ChangePassword() {
    if (
      editData.OLD_PASSWORD !== undefined &&
      editData.PASSWORD !== undefined &&
      editData.CONFIRM_PASSWORD !== undefined
    ) {
      let functionName = "";
      try {
        functionName = ChangePassword.name;
        props.onLoading(true, "Changing password, please wait...");
        var encryptedOld = common.c_EncryptData(editData.OLD_PASSWORD.trim());
        var encrypted = common.c_EncryptData(editData.PASSWORD.trim());
        const data = {
          USER_ID: userId,
          // USER_SHORT_NAME: editData.USER_SHORT_NAME,
          PASSWORD: encrypted.toString(),
          OLD_PASSWORD: encryptedOld.toString(),
          // UPDATE_ID: userId,
        };
        http
          .put("api/login/UserChangePassword", data, { timeout: 5000 })
          .then((response) => {
            if (
              response.data.VALID === "PASSWORD_REPEAT" ||
              response.data.VALID === "PASSWORD_INVALID" ||
              response.data.VALID === "INVALID_PASSWORD"
            ) {
              // setEditData((prevState) => ({
              //   ...prevState,
              //   ERROR_MSG: response.data.ERROR_MSG,
              // }));
              setInputError((prevState) => ({
                ...prevState,
                CONFIRM_PASSWORD: response.data.ERROR_MSG,
              }));
              toast.error("Failed to change password.");
            } else {
              toast.success("Password is successfully change.");
              hideModal();
              props.showHideChangePasswordModal();
            }
          })
          .catch((err) => {
            toast.error("Failed to change password. Please try again.1");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            props.onLoading(false, "Loading...");
          });
      } catch (err) {
        props.onLoading(false, "Loading...");
        toast.error("Failed to change password. Please try again.2");
        common.c_LogWebError(props.page, functionName, err);
      }
    }
  }

  function furtherValidateInput(id, val) {
    if (id === "CONFIRM_PASSWORD") {
      var PASSWORD = editData.PASSWORD;
      if (PASSWORD !== val) {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: "Please confirm the passwords are match.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: "",
        }));
      }
    } else {
      var CPASSWORD = editData.CONFIRM_PASSWORD;
      if (CPASSWORD !== val) {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: "Please confirm the passwords are match.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: "",
        }));
      }
    }
  }

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: name + " could not be empty.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
        furtherValidateInput(id, val);
      }
      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered>
        <Modal.Header>
          <div style={{ backgroundColor: "lightgrey", width: "100%" }}>
            <Modal.Title>CHANGE PASSWORD</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Comp.Input
            ref={oldPasswordInputRef}
            id="OLD_PASSWORD"
            label="Old Password*:"
            name="Password"
            type="password"
            className="form-control"
            errorMessage={inputError.OLD_PASSWORD}
            value={editData.OLD_PASSWORD}
            onChange={inputRequiredHandler}
          />
          <Comp.Input
            ref={userPasswordInputRef}
            id="PASSWORD"
            label="New Password*:"
            name="Password"
            type="password"
            className="form-control"
            errorMessage={inputError.PASSWORD}
            value={editData.PASSWORD}
            onChange={inputRequiredHandler}
          />
          <Comp.Input
            ref={userCPasswordInputRef}
            id="CONFIRM_PASSWORD"
            label="Confirm Password*:"
            name="Confirm New Password"
            type="password"
            className="form-control"
            errorMessage={inputError.CONFIRM_PASSWORD}
            value={editData.CONFIRM_PASSWORD}
            onChange={inputRequiredHandler}
          />
        </Modal.Body>
        <Modal.Footer>
          <div style={{ textAlign: "center", width: "100%" }}>
            <Comp.Button id="btnSave" onClick={saveBtnOnClick}>
              Save  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
            </Comp.Button>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <Comp.Button id="btnCancel" type="cancel" onClick={hideModal}>
              Cancel  <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
            </Comp.Button>
            <p
              style={{
                color: "rgb(255,0,0)",
                marginTop: "5px",
                fontSize: "smaller",
              }}
            >
              {editData.ERROR_MSG}
            </p>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChangePasswordModal;
